export enum ApplicationStatusEnum {
    Approved = 'APPROVED',
    AwardCommittee = 'AWARD_COMMITTEE',
    Denied = 'DENIED',
    Draft = 'DRAFT',
    InReview = 'IN_REVIEW',
    OnHold = 'ON_HOLD',
    PreAwardCommittee = 'PRE_AWARD_COMMITTEE',
    Submitted = 'SUBMITTED'
}
